import breakpoints from '@rc-d2c/styles/variables/_breakpoints.scss';
import debounce from 'lodash/debounce';
import { useLayoutEffect, useState } from 'react';

const { desktop } = breakpoints;

export const useGetScreenSize = (targetSize = desktop): boolean => {
  const [isScreenLargerThenTarget, setIsScreenLargerThenTarget] = useState(innerWidth > Number(targetSize));

  useLayoutEffect(() => {
    const updateSize = (): void => {
      setIsScreenLargerThenTarget(innerWidth > Number(targetSize));
    };
    addEventListener('resize', debounce(updateSize, 200));

    return (): void => removeEventListener('resize', updateSize);
  }, []);

  return isScreenLargerThenTarget;
};

export default useGetScreenSize;
